import { render, staticRenderFns } from "./Clues.vue?vue&type=template&id=a9d9966a&"
import script from "./Clues.vue?vue&type=script&lang=js&"
export * from "./Clues.vue?vue&type=script&lang=js&"
import style0 from "./Clues.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports